<template>
	<label class="cursor-pointer" @click="check">
		<div class="checker inv-checker">
			<span :class="{ 'checked' : checked }"></span>
		</div>
		<slot></slot>
	</label>
</template>

<script>
	import _ from 'lodash';

	export default {
		props: {
			value: {
				required: true,
			},
			onValue: {
				default: null
			},
			offValue: {
				default: null
			}
		},
		data() {
			return {
				checkboxValue: this.value,
				checkboxOn: true,
				checkboxOff: false,
				checked: false,
			};
		},
		mounted() {
			if (! _.isNil(this.onValue)) {
				this.checkboxOn = this.onValue;
			}

			if (! _.isNil(this.offValue)) {
				this.checkboxOff = this.offValue;
			}

			this.checked = this.value === this.checkboxOn;
			this.checkboxValue = this.getValue();
		},
		methods: {
			/**
			 * Toggle checked.
			 */
			check() {
				this.checked = ! this.checked;
				this.checkboxValue = this.getValue();
				this.$emit('input', this.checkboxValue);
				this.$emit('click', this.checkboxValue);
			},

			/**
			 * Get the checkbox value.
			 */
			getValue() {
				return this.checked ? this.checkboxOn : this.checkboxOff;
			}
		}
	}
</script>